<template>
   <section class="rr-pl">

   </section>
</template>
<script>
//import Button from 'primevue/button';
//import Card from 'primevue/card';

export default {
    name: "PriceList",
    components: {
    }
}
</script>
<style scoped lang="scss">

</style>
